import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import moment from "moment";
import { routes } from "utilities/routing/generatedRoutes";
import { ButtonSecondary } from "components/Atoms/Button";
import { captureException } from "@sentry/browser";
import { useLoaderData } from "react-router";

const WebformList = () => {
  const viewModel = useLoaderData<server.viewmodel.WebformListFrontModel>();
  const [isNewButtonLoading, setIsNewButtonLoading] = React.useState(false);

  const onNewWebform = async () => {
    setIsNewButtonLoading(true);
    try {
      const res = await window.CoreApi.WebformConfiguration.Create();
      if (res.data.hasErrors) {
        console.error(res.data.errors);
        setIsNewButtonLoading(false);
      } else {
        window.location.href = routes.webform_Detail(res.data.data).absolute;
      }
    } catch (e) {
      setIsNewButtonLoading(false);
      captureException(e);
      console.error(e);
    }
  }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        articleId={serverReference.supportArticleIds.whatAreBookingRequestForms}
        title={viewModel.pageTitle}
        filterSet="webform_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.WebformConfiguration.Paginated}
        getId={item => item.webformId}
        onNew={onNewWebform}
        isNewButtonLoading={isNewButtonLoading}
        layout={{
          type: "table",
          columns: [
            {
              header: RESX.GeneralLabels.Title,
              key: "title",
              size: "1fr",
              render: item => <a href={routes.webform_Detail(item.webformId).absolute}>{item.title}</a>
            }, {
              header: RESX.GeneralLabels.LastModified,
              key: "lastModified",
              size: "1fr",
              render: item => <div>{moment.utc(item.lastModifiedUtc).fromNow()}</div>
            }, {
              header: "",
              key: "formUrl",
              render: item => <ButtonSecondary label={RESX.Webform.PreviewForm} onClick={() => window.open(item.formUrl)} />
            }

          ]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
  </TwoColumnLayout>
};


export default WebformList;